import type { AuditMessages, Dictionary } from '../models'
import { AuditActionEnum } from '@empathybroker/tsclient-play/dist/enums/audit-action.enum'
import { EngagementActionsTypeEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-actions-type.enum'

import { EngagementTypeComponentEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-type-component.enum'

import { AuditSortFieldEnum, LocaleEnum, TaggingTypeEnum } from '../enums'

const AUDIT_MESSAGES_EN: AuditMessages = {
  search: {
    placeholder: 'Search',
  },
  tagging: {
    modes: {
      [TaggingTypeEnum.VIEW]: {
        label: 'Views',
        description: 'Number of views',
      },
      [TaggingTypeEnum.ACTION]: {
        label: 'Actions',
        description: 'Number of interactions',
      },
    },
    actions: {
      [EngagementActionsTypeEnum.CREATE]: {
        label: 'Create',
        description: 'Actions performed to create a new configuration',
      },
      [EngagementActionsTypeEnum.EDIT]: {
        label: 'Update',
        description: 'Actions performed to edit an existing configuration',
      },
      [EngagementActionsTypeEnum.DELETE]: {
        label: 'Delete',
        description: 'Actions performed to delete a configuration',
      },
      [EngagementTypeComponentEnum.DOWNLOAD]: {
        label: 'Download',
        description: 'Actions performed to download',
      },
      [EngagementActionsTypeEnum.SEARCH]: {
        label: 'Search',
        description: 'Actions performed to Search',
      },
    },
    noDataFound: 'No data found for this period and filters. Please, try other values.',
  },
  entry: {
    actions: {
      [AuditActionEnum.CREATE]: '<b>Created</b> an entry',
      [AuditActionEnum.UPDATE]: '<b>Edited</b> an entry',
      [AuditActionEnum.DELETE]: '<b>Deleted</b> an entry',
      [AuditActionEnum.DOWNLOAD]: '<b>Downloaded</b> a report',
      [AuditActionEnum.SEARCH]: '<b>Searched</b> for a query',
    },
    previousState: 'Previous state',
    nextState: 'Next state',
    changingElements: {
      created: '{count} added',
      updated: '{count} modified',
      deleted: '{count} removed',
    },
  },
  sort: {
    [AuditSortFieldEnum.DATE]: {
      label: 'Date',
      groups: {
        today: 'Today',
        yesterday: 'Yesterday',
      },
    },
  },
  loadMore: 'Load more',
  noDataFound: 'No activities found',
}

const AUDIT_MESSAGES_ES: AuditMessages = {
  search: {
    placeholder: 'Buscar',
  },
  tagging: {
    modes: {
      [TaggingTypeEnum.VIEW]: {
        label: 'Visitas',
        description: 'Número de visualizaciones',
      },
      [TaggingTypeEnum.ACTION]: {
        label: 'Acciones',
        description: 'Número de interacciones',
      },
    },
    actions: {
      [EngagementActionsTypeEnum.CREATE]: {
        label: 'Creación',
        description: 'Acción realizada para crear una configuración',
      },
      [EngagementActionsTypeEnum.EDIT]: {
        label: 'Actualización',
        description: 'Acción realizada para cambiar una configuración existente',
      },
      [EngagementActionsTypeEnum.DELETE]: {
        label: 'Eliminación',
        description: 'Acción realizada para eliminar una configuración',
      },
      [EngagementTypeComponentEnum.DOWNLOAD]: {
        label: '',
        description: '',
      },
      [EngagementActionsTypeEnum.SEARCH]: {
        label: '',
        description: '',
      },
    },
    noDataFound:
      'No se han encontrado datos para este periodo y filtros. Por favor, pruebe otros valores.',
  },
  entry: {
    actions: {
      [AuditActionEnum.CREATE]: '<b>Creó</b> una entrada',
      [AuditActionEnum.UPDATE]: '<b>Editó</b> una entrada',
      [AuditActionEnum.DELETE]: '<b>Borró</b> una entrada',
      [AuditActionEnum.DOWNLOAD]: '',
      [AuditActionEnum.SEARCH]: '',
    },
    previousState: 'Estado previo',
    nextState: 'Estado siguiente',
    changingElements: {
      created: '{count} añadido(s)',
      updated: '{count} modificado(s)',
      deleted: '{count} eliminado(s)',
    },
  },
  sort: {
    [AuditSortFieldEnum.DATE]: {
      label: 'Fecha',
      groups: {
        today: 'Hoy',
        yesterday: 'Ayer',
      },
    },
  },
  loadMore: 'Cargar más',
  noDataFound: 'No se han encontrado actividades',
}

export const AUDIT_MESSAGES: Dictionary<{ audit: AuditMessages }> = {
  [LocaleEnum.ENGLISH]: {
    audit: AUDIT_MESSAGES_EN,
  },
  [LocaleEnum.SPANISH]: {
    audit: AUDIT_MESSAGES_ES,
  },
}
